/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
import {Injectable} from '@angular/core';
import {AppConfigService} from '../../../../common/service/app-config.service';
import {EsriModuleService} from '../../../esri-nlr/services/esri-module.service';

@Injectable({
    providedIn: 'root'
})
export class EnlargementGraphicToolService {
    constructor(
        private appConfigService: AppConfigService,
        private esriModuleService: EsriModuleService
    ) {}

    title = 'EnlargementGraphicToolService';
    allGraphics = [];

    deactivateTool = function (toolbar) {
        toolbar.deactivate();
    };

    activateTool(toolbar, type) {
        switch (type) {
            case 'POLYGON':
                toolbar.activate(this.esriModuleService.Draw['POLYGON']);
                break;
            case 'FREEHAND_POLYGON':
                toolbar.activate(this.esriModuleService.Draw['FREEHAND_POLYGON']);
                break;
        }
    }

    differencePolygon(geometry, parentGeometry, callback) {
        const geometryService = new this.esriModuleService.GeometryService(this.appConfigService.getDesignProperties().GEOMETRY_SERVER_URL);
        geometryService.difference(
            [parentGeometry],
            geometry,
            result => {
                if (callback) {
                    const graphic = new this.esriModuleService.Graphic(result[0]);
                    callback(graphic);
                }
            },
            () => {
                callback(undefined);
            }
        );
    }
}
